const BLOCKED_PROFILE_KEY = '760ED9B8-8A40443C-BABEB038-E67FC39F';

export const isBlockedProfile = (profileKey: string) => {
	return profileKey === BLOCKED_PROFILE_KEY;
};
